module.exports = __webpack_public_path__ + "img/carouselRight.42209595.svg";